module.exports = __webpack_public_path__ + "static/media/moonstone-lamp-img1.f5c1f0ef.jpg";